export const AiVidiosIcon2626 = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17 2H7C4.243 2 2 4.243 2 7V17C2 19.757 4.243 22 7 22H17C19.757 22 22 19.757 22 17V7C22 4.243 19.757 2 17 2ZM20 11H18V9H20V11ZM6 11H4V9H6V11ZM4 13H6V15H4V13ZM18 13H20V15H18V13ZM20 7H18V4.18408C19.161 4.59808 20 5.698 20 7ZM6 4.18408V7H4C4 5.698 4.839 4.59808 6 4.18408ZM4 17H6V19.8159C4.839 19.4019 4 18.302 4 17ZM18 19.8159V17H20C20 18.302 19.161 19.4019 18 19.8159Z"
      fill="#41416E"
    />
  </svg>
);
